<template>
  <!-- 兑换码编辑 -->
  <div class="el-card pd20 special">
    <!-- 返回 -->
    <div class="cancel-box">
      <el-button type="info" icon="el-icon-arrow-left" @click="$router.go(-1)" size="medium">返回统计列表</el-button>
    </div>
    <el-divider></el-divider>
    <!-- form -->
    <el-form :model="form" :rules="rules" ref="form">
      <!-- 名称 -->
      <el-form-item label="兑换码名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" placeholder="请输入兑换码名称"></el-input>
      </el-form-item>
      <!-- 测评 -->
      <el-form-item label="测评" prop="product_id" :label-width="formLabelWidth">
        <el-select v-model="form.product_id" placeholder="请选择测评">
          <el-option
            v-for="item in list"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 兑换码数量 -->
      <el-form-item label="兑换码数量" prop="count" :label-width="formLabelWidth">
        <el-input v-model="form.count" placeholder="请输入兑换码数量"></el-input>
      </el-form-item>

      <!--  -->
      <el-form-item :label-width="formLabelWidth">
        <el-button type="primary" @click="submitForm('form')">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template> 

<script>
import { addCode, productAll } from "@/api/measurement";
export default {
  data() {
    return {
      formLabelWidth: "120px",
      list: [],
      form: {
        name: "",
        product_id: null,
        count: null
      },
      options: [],
      //这是一个验证规则
      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }
        ],
        product_id: [
          {
            required: true,
            message: "请输入请选择测评产品",
            trigger: ["blur","change"]
          }
        ],
        count: [
          {
            required: true,
            message: "请输入生成数量",
            trigger: "blur"
          }
        ]
      }
    }
  },
  methods: {
    // 提交数据
    save() {
        // 添加
        addCode(this.form).then(data => {
          if (data.error > 0) {
            this.$message(data.msg);
            return;
          }
          this.$notify({
            title: "成功",
            message: "提交成功！",
            type: "success"
          });
          this.$router.go(-1);
        });
      
    },
    //
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          this.$message.warning("请检查数据是否为空？");
          return false;
        }
      });
    },
    pullData() {
      this.$showLoading();
      
      // type 1 单个商品 2 套餐商品
      productAll({
        type:'1,2'
      }).then(data=>{
        this.list = data.list;
        this.$hideLoading();
      }).catch(err=>{
        this.$hideLoading();
      });
    }
  },
  created() {
    this.pullData();
  }
};
</script>

<style lang="scss" scoped>
.special {
  .el-input,
  .el-textarea {
    width: 775px;
  }
  .price {
    width: 500px;
    margin-right: 20px;
  }
}

.cancel-box {
  margin-bottom: 20px;
}
.up-image {
  margin: 20px auto auto;
  width: 187.5px;
  text-align: center;
  border-radius: 8px;
  .error {
    border-radius: 8px;
    background-color: rgba($color: #eeeeee, $alpha: 0.5);
  }
}
.auto-hour {
  margin-right: 20px;
  border-radius: 4px;
  padding: 8px 0px;
  padding-left: 15px;
}
.el-form-item {
  p {
    color: #999999;
  }
}
</style>
<style lang="scss">
// .special .el-select .el-input.is-disabled .el-input__inner{
//     background: rgba(0,0,0,0.6)!important;
// }
.el-date-editor .el-range-separator {
  width: 7%;
}
</style>
